/**
	WDFetchArray
	- what would this do?  Create a fetch and just store all the results?  What are we accessing,
		the results or the fetch object itself?  wouldn't be able to subclass this either.  May just
		be easier to assign the results of WDFetch into a proxy array
		
		other possibilities
		- can always access the fetch from within this, teh results are part of the core object
		- the results are an array of WDFetchObjects that can be worked with
		- parameters are the same as WDFetch, but we create a fetch object that can be accessed
		- directly as needed.  
	*/

import { WDModelArray } from '../wd-model';
import WDFetch from './wd-fetch';

export default class WDFetchArray extends WDModelArray {

	__fetch;

	constructor(uri,params)
	{
		super();

		this.__fetch = new WDFetch(uri,params);
	};

	get fetch() { return this.__fetch; };

	get canFetch()
	{
		return this.fetch.getReqURI().length > 0;
	};

	req(method)
	{
		if (!method) mode = 'GET';
		
		return this.__fetch.req(method).then( results => {
			if (results instanceof Array) 
			{
				this.batchUpdate( () => {
					this.replace(results);
				});
			}
			return results;
		});
	};

	/**
	 * Cleanup method to abort pending requests and clear resources
	 */
	destroy() {
		// Destroy the internal fetch instance
		if (this.__fetch && this.__fetch.destroy) {
			this.__fetch.destroy();
		}
		this.__fetch = null;
		
		// Clear the array data
		this.clear();
		
		// Call parent destroy if available
		if (super.destroy) {
			super.destroy();
		}
		
		return this;
	}

};

